<template>
  <b-container fluid>
    <backlink />
    <h1>Attributs de demande</h1>
    <p class="text-muted">Champs proposés dans le formulaire de demande de location pour compte. Un attribut est défini ici, puis activé matériel par matériel depuis la fiche du produit.</p>
    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "RequestAttributeList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      return {
        field_type_options: this.$store.getters["request_attribute/getFieldTypesForSelect"],
        // Racines et sous-familles, hiérarchisées (« -- » devant les sous-familles).
        // « Sans famille » n'est pas un artifice : seize attributs relèvent d'« Engins de
        // chantier », que le paramétrage client marque lui-même « à créer ».
        equipment_group_paths_options: [{ value: "none", text: "Sans famille" }].concat(
          this.$store.getters["equipment_group/getAllForSelect"]
        ),
      };
    },
  },
  created() {
    // Vocabulaires servis par l'API : ils alimentent les libellés de la liste et les
    // listes déroulantes du formulaire.
    this.$store.dispatch("request_attribute/getOptions");
    this.$store.dispatch("equipment_group/getAll");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RequestAttribute/RequestAttributeList.vue